import { render, staticRenderFns } from "./_FilterDetailText.vue?vue&type=template&id=27fa36b0&"
import script from "./_FilterDetailText.vue?vue&type=script&lang=js&"
export * from "./_FilterDetailText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports